// extracted by mini-css-extract-plugin
module.exports = {"MainPromoBlock":"TVjgS","MainPromoBlock__Image":"z9AfB","MainPromoBlock__Content":"eH1tR","MainPromoBlock__Title":"shPQz","MainPromoBlock__Description":"nUZ3x"};